import { render, staticRenderFns } from "./icon-model.vue?vue&type=template&id=2b6568a6&scoped=true"
import script from "./icon-model.vue?vue&type=script&lang=js"
export * from "./icon-model.vue?vue&type=script&lang=js"
import style0 from "./icon-model.vue?vue&type=style&index=0&id=2b6568a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6568a6",
  null
  
)

export default component.exports